import { render, staticRenderFns } from "./School.vue?vue&type=template&id=51891258&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"
import style0 from "./School.vue?vue&type=style&index=0&id=51891258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51891258",
  null
  
)

export default component.exports